<template>
  <div class="v-layout-loading">
    <v-spinner
      line-fg-color="var(--light-gray)"
      line-bg-color="var(--lighter-gray)"
      class="spinner"
    />
  </div>
</template>

<script>
export default {
  name: "VLayoutLoading"
};
</script>
